<template>
  <div class="container">
    <p style="font-weight:bold;font-size:16px">站点商品数据爬虫</p>
    <div>
      <el-input placeholder="请输入站点链接" v-model="params.url" class="input">
        <el-select v-model="params.type" slot="prepend" placeholder="请选择" style="width:110px">
          <el-option label="店匠" value="18"></el-option>
          <el-option label="Shopify" value="7"></el-option>
          <el-option label="Shopline" value="19"></el-option>
          <el-option label="Xshoppy " value="22"></el-option>
          <el-option label="Bigcommerce" value="21"></el-option>
        </el-select>
      </el-input>
      <el-button style="margin-left: 16px" type="primary" @click="search" :disabled="!!timer">
        {{ !!timer ? '爬取中' : '爬取' }}
      </el-button>
      <el-button type="text" @click="stopSpider" v-if="!!timer">停止爬取</el-button>
    </div>
    <div class="loading" v-if="!!timer">
      <i class="el-icon-loading"></i>
      <span>爬取数据需要等待一段时间，请耐心等待…</span>
    </div>
    <el-table :data="data" :max-height="400" @sort-change="sortChange" style="margin-top: 29px;">
      <el-table-column prop="spuId" label="spuId" min-width="130"></el-table-column>
      <el-table-column prop="productName" label="商品名称" min-width="130"></el-table-column>
      <el-table-column prop="imageUrl" label="图片" min-width="130">
        <template slot-scope="{ row }">
          <img :src="row.imageUrl" style="width:40px;height:40px" v-if="row.imageUrl" />
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="品类" min-width="130"></el-table-column>
      <el-table-column prop="currency" label="币种" min-width="100"></el-table-column>
      <el-table-column prop="price" label="价格" min-width="130"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="130" sortable></el-table-column>
      <el-table-column prop="publishTime" label="发布时间" width="130" sortable></el-table-column>
      <el-table-column prop="updateTimeupdateTime" label="更新时间" width="130" sortable></el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNum"
      :page-size="pagination.pageSize"
      layout="total, prev, pager, next"
      :total="pagination.total"
      style="align-self: flex-end;margin-top:16px"
    ></el-pagination>
    <!-- <z-table
      :data="data"
      :columns="columns"
      :pagination="pagination"
      :max-height="500"
      border
      @page-change="search"
      :customDefault="{ text: '该站点暂无商品', height: '390px' }"
    ></z-table> -->
  </div>
</template>

<script>
import { startSpider } from '@/server/other.js'
import { getReptileData } from '@/server/etl.js'
import { camel2Under } from '@/utils/camal-case-covertor.js'
export default {
  data() {
    return {
      params: {
        url: '',
        type: '18',
        sortWord: '',
        sortType: '',
        orgUnitId: this.$store.state.user.merchantId
      },
      data: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      timer: null
    }
  },
  methods: {
    async search() {
      if (!this.params.url) {
        this.$message.error('请输入站点链接')
        return
      }
      const { data } = await startSpider(this.params)
      if (data.code === this.$code) {
        this.getData()
        this.timer = setInterval(() => {
          this.getData()
        }, 30000)
      }
    },
    async getData() {
      let params = { ...this.params, ...this.pagination }
      if (!params.sortType) {
        delete params.sortType
        delete params.sortWord
      }
      const { data } = await getReptileData(params)
      if (data.code == this.$code) {
        this.data = data.data.datas
        this.pagination.total = data.data.totalSize
      }
    },
    sortChange(data) {
      this.params.sortWord = camel2Under(data.prop)
      let type = { ascending: 'ASC', descending: 'DESC' }
      if (data.order) {
        this.params.sortType = type[data.order]
      } else {
        this.params.sortType = null
      }
      this.getData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getData()
    },
    stopSpider() {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  deactivated() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped lang="scss">
.container {
  // margin: 24px;
  background: #ffffff;
  border-radius: 6px;
  padding: 32px 60px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.input {
  width: 520px;
  margin: 32px 0 8px;
}
.loading {
  margin-top: 29px;
  color: #666666;
  display: flex;
  align-items: center;
}
.el-icon-loading {
  color: #0061ff;
  animation: rotating 2s linear infinite;
  margin-right: 18px;
  font-size: 18px;
}
</style>
